import { BaseRouteService } from 'core/services';

class PickingBatchViewRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'picking-batch-views/';
	}

	find(filter) {
		return super.create(this.base + 'search', filter);
	}

	exportToCsv(filter) {
		return super.create(this.base + 'export', filter);
	}
}

export default PickingBatchViewRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/PickingBatchViewRouteService.js